<template>
    <div class="w-100 spd_footer">
        <p>© 2025 SPD</p>
        <p class="disclaimer">Zadavatel: SPD. Zpracovatel: Praha Na Vlastní Oči, s.r.o.</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

<style lang="scss">
</style>